import React, { useState, useId, useEffect } from "react";
import styled from "styled-components";
import { Camera, PlaceholderImg, TrashRedIcon } from "../../styled/AllImages";
import { useTranslation } from "react-i18next";

const ProfileUpload = ({ onFileSelect, initialImage, file }) => {

  const { t } = useTranslation();
  const [selectedImage, setSelectedImage] = useState(
    initialImage ? initialImage : PlaceholderImg
  ); // Store selected image
  const uniqueId = useId(); // Generate a unique ID for each instance

  // Synchronize selectedImage with changes to initialImage
  /* useEffect(() => {
        if (initialImage) {
            setSelectedImage(initialImage);
        }
    }, [initialImage]); */

  // Update `selectedImage` only when `initialImage` changes externally
  useEffect(() => {
    if (initialImage !== selectedImage && !selectedImage.startsWith("blob:")) {
      setSelectedImage(initialImage || PlaceholderImg);
    } 
    // else if(file) setSelectedImage(file);
  }, [initialImage, selectedImage]);
  useEffect(() => {
    let objectUrl;

    if (initialImage instanceof File) {
      objectUrl = URL.createObjectURL(initialImage);
      setSelectedImage(objectUrl);
    } else if (typeof initialImage === "string") {
      setSelectedImage(initialImage);
    } else {
      setSelectedImage(PlaceholderImg);
    }

    return () => {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [initialImage]);

  // useEffect(() => {
  //     if(file && initialImage !== selectedImage && !initialImage) setSelectedImage(file)
  // }, [file, initialImage, selectedImage])

  // useEffect(() => {
  //     if(file) setSelectedImage(file || PlaceholderImg);
  // }, [file]);

  /* useEffect(() => {
        if (!initialImage || initialImage === PlaceholderImg) {
            setSelectedImage(PlaceholderImg);
        } else {
            setSelectedImage(initialImage);
        }
    }, [initialImage]); */
  // Update selectedImage when initialImage changes
  // useEffect(() => {
  //     setSelectedImage(initialImage || PlaceholderImg);
  // }, [initialImage]);

  // Function to handle file selection (image upload)
  const handleFileChange = (event) => {
    const inputFile = event.target.files[0];
    if (inputFile) {
      const fileURL = URL.createObjectURL(inputFile); // Generate a URL for the selected image
      setSelectedImage(fileURL); // Store the image URL
      onFileSelect(inputFile); // Emit the file to the parent
    }
  };

  // Function to remove the selected image
  const handleRemoveImage = () => {
    setSelectedImage(PlaceholderImg); // Reset the image
    onFileSelect(PlaceholderImg); // Clear the file in the parent
  };

  return (
    <UploadContainer className="uploadImgContainer">
      <ImagePreviewContainer>
        <ImagePreview src={selectedImage} alt="Selected" />
      </ImagePreviewContainer>
      {/* {selectedImage === PlaceholderImg ? (
                <DefaultUploadBox className='defaultUploadBox' onClick={() => document.getElementById(`imageInput-${uniqueId}`).click()}>
                    <Camera />
                    <UploadText>{t(UploadImage)}</UploadText>
                </DefaultUploadBox>
            ) : (
                <RemoveButton onClick={handleRemoveImage}>
                    <TrashRedIcon />
                </RemoveButton>
            )} */}

      <DefaultUploadBox
        className="defaultUploadBox"
        onClick={() =>
          document.getElementById(`imageInput-${uniqueId}`).click()
        }
      >
        <Camera />
        {/* <UploadText>{t(UploadImage)}</UploadText> */}
      </DefaultUploadBox>

      {/* Hidden file input */}
      <input
        id={`imageInput-${uniqueId}`} // Use the unique ID here
        type="file"
        accept="image/png, image/jpeg, image/jpg" // Accept only image files
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
    </UploadContainer>
  );
};

export default ProfileUpload;

// Styled components
const UploadContainer = styled.div`
  display: block;
  width: 110px;
  height: 110px;
  border-radius: 50%;
  position: relative;
`;

const DefaultUploadBox = styled.div`
  position: absolute;
  background-color: var(--themeColor2);
  border: 2px solid var(--white);
  border-radius: 50%;
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 4px;
  right: -12px;
  cursor: pointer;
`;

const UploadText = styled.p`
  font-size: 14px;
  margin-top: 7px;
  color: var(--text2);
  line-height: 18px;
`;

const ImagePreviewContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  overflow: hidden;
  border: 1px solid var(--border);
`;

const ImagePreview = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const RemoveButton = styled.button`
  position: absolute;
  background-color: var(--redColor);
  border: 2px solid var(--white);
  border-radius: 50%;
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 4px;
  right: -12px;
  cursor: pointer;
  svg {
    width: 24px;
    height: auto;
    [fill] {
      fill: var(--white);
    }
    [stroke] {
      stroke: var(--white);
    }
  }
`;
